import { HStack, VStack } from '@cbhq/cds-web/layout';
import { TextBody } from '@cbhq/cds-web/typography';

type ContentRowProps = Readonly<{
  description: string;
  detail: string;
}>;

export function ContentRow({ description, detail }: ContentRowProps) {
  return (
    <VStack>
      <HStack justifyContent="space-between" spacingVertical={3}>
        <TextBody as="p" color="foregroundMuted">
          {description}
        </TextBody>
        <TextBody as="p">{detail}</TextBody>
      </HStack>
    </VStack>
  );
}
